import { tv, type VariantProps } from 'tailwind-variants'

export type ButtonVariant = VariantProps<typeof button_recipe>

export const button_recipe = tv({
  base: 'cursor-pointer transition',
  variants: {
    variant: {
      solid: '',
      ghost: '',
      plain: '',
      outline: '',
    },

    size: {
      none: '',
      xs: 'px-2 py-1',
      sm: 'px-3 py-2',
      md: 'px-4 py-3',
      lg: 'px-6 py-3',
      xl: 'px-6 py-4',
    },

    colorPalette: {
      brand: '',
      gray: '',
      black: '',
      white: '',
      secondary: '',
    },
  },
  compoundVariants: [
    {
      variant: 'solid',
      colorPalette: 'brand',
      class: 'bg-brand text-white hover:bg-brand-600',
    },
    {
      variant: 'outline',
      colorPalette: 'brand',
      class: 'border border-brand text-brand',
    },

    {
      variant: 'plain',
      colorPalette: 'brand',
      class: 'text-brand',
    },

    {
      variant: 'solid',
      colorPalette: 'gray',
      class: 'bg-gray-400 text-gray-900',
    },
    {
      variant: 'plain',
      colorPalette: 'black',
      class: 'text-black hover:text-brand',
    },
    {
      variant: 'plain',
      colorPalette: 'white',
      class: 'text-white hover:text-brand',
    },
    {
      variant: 'solid',
      colorPalette: 'secondary',
      class: 'bg-secondary text-black hover:bg-secondary-600',
    },
  ],
  defaultVariants: {
    variant: 'solid',
    size: 'md',
  },
})
